import { useEffect, useRef, useState } from 'react';

export default function CodeChainFlow() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-16 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12">
          <h2
            className={`text-2xl md:text-4xl font-bold text-primary-600 mb-4 transition-all duration-600 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            物码全链路系统图
          </h2>
          <p
            className={`text-sm md:text-base text-foreground-600 max-w-2xl mx-auto transition-all duration-600 delay-150 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            一物一码，五码关联，覆盖产品全生命周期，实现从生产到消费的全链路数字化追溯
          </p>
        </div>

        {/* Image Card */}
        <div
          className={`bg-white rounded-2xl border border-background-200/70 overflow-hidden transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '300ms' }}
        >
          {/* Main Image */}
          <div className="p-6 md:p-8 lg:p-10">
            <div className="relative w-full rounded-xl overflow-hidden bg-background-50/50 border border-background-200/50">
              <img
                src="/images/code-chain-flow.png"
                alt="物码全链路系统图"
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>

          {/* Bottom Summary */}
          <div className="px-6 md:px-8 lg:px-10 pb-8 pt-2 border-t border-background-100">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4 py-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-primary-50 flex items-center justify-center">
                <i className="ri-lightbulb-line text-primary-500 text-lg" />
              </div>
              <div>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  <strong className="text-primary-600">物码全链路</strong>通过"一物一码"技术，为每件产品赋予唯一数字身份，
                  覆盖从生产赋码到消费者扫码的全链路，实现<span className="font-bold text-primary-600">防伪溯源</span>、
                  <span className="font-bold text-primary-600">渠道管控</span>、
                  <span className="font-bold text-primary-600">精准营销</span>三大核心价值。
                </p>
                <div className="flex flex-wrap gap-2 mt-3">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-bold rounded-lg border border-primary-200/50">
                    <i className="ri-qr-scan-line text-xs" />
                    一物一码
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-bold rounded-lg border border-secondary-200/50">
                    <i className="ri-link-m text-xs" />
                    五码关联
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-100 text-accent-700 text-xs font-bold rounded-lg border border-accent-200/50">
                    <i className="ri-route-line text-xs" />
                    全链路可追溯
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}